<template lang='pug'>
    div.changelist.page
        p Current Deployment is always on:
        a(href="https://sacrifice.now.sh/") sacrifice.now.sh
        h1 Log
        section
            h2 Interface
            p loots of small interface improvements and named colors
            a(href="https://sacrifice-oyajzoels.now.sh/") sacrifice-oyajzoels.now.sh
        section
            h2 Buttons & Layout
            p "smart" :) buttons and layout
            a(href="https://sacrifice-q900vsbby.now.sh/") sacrifice-q900vsbby.now.sh
        section
            h2 styles
            p first try of visually cleaning up and making flow clear
            a(href="https://sacrifice-q1b6cwcc8.now.sh/") sacrifice-q1b6cwcc8.now.sh
        section
            h2 performance
            p everything runs much faster! cleanup happens now on every mouse release
            a(href="https://sacrifice-pjwfn89np.now.sh") sacrifice-pjwfn89np.now.sh
        section
            h2 draw pages
            p dedicated page for drawing. Color switch like "ink" that runs out
            a(href="https://sacrifice-knzpoxvq5.now.sh/draw") sacrifice-knzpoxvq5.now.sh/draw
        section
            h2 split into sacrifice & draw pages
            p dedicated page for webcam with shared state. -> So I can turn of the webcam and allow browser navigation & eventually make intro page
            a(href="https://sacrifice-m3d9cc607.now.sh/sacrifice") sacrifice-m3d9cc607.now.sh/sacrifice
        section
            h2 Cleanup and Camera input
            p sacrifice the pixels from your webcam
            a(href="https://sacrifice-910xoewqh.now.sh/") sacrifice-910xoewqh.now.sh
        section
            h2 Tools
            p New tools and (slightly) cleaner code 👯‍♀️
            a(href="https://sacrifice-qnuta6hvd.now.sh") sacrifice-qnuta6hvd.now.sh
        section
            h2 fuck the versioning?
            p this is the first (working)? version. <br> the Cleanup button can now remove Pixel that are not found in the source image
            a(href="https://sacrifice-cbpvj6zz1.now.sh") sacrifice-cbpvj6zz1.now.sh
        section
            h2 version 0.0.2
            p updated to PUG and nice stuff…
            a(href="https://sacrifice-gk4bcmov6.now.sh") sacrifice-gk4bcmov6.now.sh
        section
            h2 version 0.0.1
            a(href="https://sacrifice-gk4bcmov6.now.sh") sacrifice-gk4bcmov6.now.sh
</template>

<script>
    export default {
        name: "changelog"
    }
</script>

<style scoped>

</style>